export const SESSION_STORAGE_FIELD_NAMES = {};

export const LOCAL_STORAGE_FIELD_NAMES = {
    CSRF_IDENTIFIER: 'csrfIdentifier',
    IS_LOGGED_IN: 'isLoggedIn',
};
